//suspended.module.scss

import { useActionData,useLoaderData, useSubmit, useLocation,useNavigate } from 'react-router-dom';

import tac from './info.module.scss';
import {logout} from '../../../components/dropdown'; 

import { loaderPostFetch } from '../util';
import {wpUser} from '../../../../k';

export async function ploader({ params }) {
  const formData = new FormData();
  formData.append('getsinfo', 'getsinfo');

  let tok = window.localStorage.getItem('sbaUid');
  if (tok != null) {
    formData.append('token', tok);
  }
  const profile = await loaderPostFetch(`api/users.php`, formData);
  console.log({profile});
  //const sessions = await getfetch(`${apiUrl}/sessionlist`, {});
  return { ...params, ...profile };
}

export function susaction(){

}
export default function InfoUser() {
  //const { state } = useLocation();
  const submit = useSubmit();



  const req=useLoaderData();

  return (
    <>

    <div className={tac.topq}>

	    <div className={tac.img}> 
	        <img src={`${wpUser}/b/logo.png`} onClick={() => {
          //window.location.href = `${wpUser}/account/`; 
          window.location.href = `${wpUser}`; 
        }} />
	    </div>

	    <button className={tac.btn3} onClick={() => {
          logout();
          window.location.href = `${wpUser}`;
        }}>
	    logout
	    </button>

    </div>

        <div className={tac.tac}>
        <div className={tac.card}>
          <div className={tac.icon}></div>
          <div className={tac.hea} style={{'whiteSpace': 'pre-line','padding':'0px 1.5rem'}}>{req?.details?.head?req?.details?.head:''}</div>
 
          <div className={tac.txt} style={{'whiteSpace': 'pre-line','padding':'0px 1.5rem'}}>
          {req?.details?.body?req?.details?.body:''} </div>

          <div className={tac.btn} onClick={() => {
          logout();
          window.location.href = `${wpUser}`;
        }}>Logout</div>



        </div></div> 
</>
);

}